/*
 * cl-shipping.js (free-shipping launch lane, 2026-10-18)
 * Opens/closes the single shared shipping-options modal (snippets/cl-shipping-modal.liquid).
 * Event delegation on document means it works for any number of "Why is free shipping slower?"
 * triggers (data-cl-shipoptions-why) on the page, including ones injected later by the mini-cart
 * drawer's AJAX refresh - no re-binding needed.
 * Idempotent: safe to include this script tag more than once on a page (same pattern as
 * cl-ship-date.js).
 * Traps Tab/Shift+Tab inside the panel while open (Codex review, 2026-10-18: Tab was reaching
 * cart/checkout controls behind the overlay) and restores focus to the trigger on close.
 */
(function () {
  'use strict';
  if (window.__CL_SHIPOPTIONS_INIT) return;
  window.__CL_SHIPOPTIONS_INIT = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var modal = document.querySelector('[data-cl-shipoptions-modal]');
    if (!modal) return;

    var lastTrigger = null;
    var FOCUSABLE_SEL = 'a[href], button:not([disabled]), input:not([disabled]), ' +
      'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getFocusable() {
      var panel = modal.querySelector('.cl-shipoptions-modal__panel');
      if (!panel) return [];
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE_SEL)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
      if (e.key !== 'Tab' && e.keyCode !== 9) return;

      var focusable = getFocusable();
      if (!focusable.length) { e.preventDefault(); return; }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (focusable.indexOf(document.activeElement) === -1) {
        // Focus somehow landed outside the panel (e.g. a programmatic focus() elsewhere) -
        // pull it back in rather than let Tab continue walking the page behind the overlay.
        e.preventDefault();
        first.focus();
      }
    }

    function open(trigger) {
      lastTrigger = trigger || null;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cl-shipoptions-modal-open');
      var closeBtn = modal.querySelector('.cl-shipoptions-modal__close');
      if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cl-shipoptions-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
    }

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;

      var trigger = target.closest('[data-cl-shipoptions-why]');
      if (trigger) {
        e.preventDefault();
        open(trigger);
        return;
      }

      var closer = target.closest('[data-cl-shipoptions-modal-close]');
      if (closer) {
        e.preventDefault();
        close();
      }
    });
  });
})();
